import { render } from "./InvestmentBarComponent.vue?vue&type=template&id=0e644f9e&scoped=true&ts=true"
import script from "./InvestmentBarComponent.vue?vue&type=script&lang=ts"
export * from "./InvestmentBarComponent.vue?vue&type=script&lang=ts"

import "./InvestmentBarComponent.vue?vue&type=style&index=0&id=0e644f9e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e644f9e"]])

export default __exports__